import * as HoverCard from "@radix-ui/react-hover-card";
import React, { useState } from "react";
type NavigationHoverItemProps = {
  cardList: React.ReactNode;
  cardTrigger: React.ReactNode;
};

const NavigationHoverItem: React.FC<NavigationHoverItemProps> = ({
  cardList,
  cardTrigger,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <HoverCard.Root open={open} onOpenChange={setOpen} openDelay={300}>
      <HoverCard.Trigger>{cardTrigger}</HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          sideOffset={10}
          align="start"
          className="bg-[#F3F3F8]  min-w-[13.856vw] h-fit z-[500] font-luxora p-[0.857vw] custom-shadow linear-border"
        >
          {cardList}
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};

export default NavigationHoverItem;
